var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcConstituciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_995",
    "data-name": "Grupo 995",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_208",
    "data-name": "Rect\\xE1ngulo 208",
    width: 45,
    height: 45,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kdpHV9.tif",
    transform: "translate(4.528 4.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_994",
    "data-name": "Grupo 994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_456",
    "data-name": "Trazado 456",
    d: "M3.8,8.426V8c.024-.112.053-.224.073-.337a4.519,4.519,0,0,1,3-3.788c.193-.072.394-.125.591-.186H31.876a.876.876,0,0,0,.158.065,4.851,4.851,0,0,1,3.961,3.7,11.25,11.25,0,0,1,.209,1.51c.1-.052.2-.11.307-.155.7-.3,1.393-.614,2.1-.89.48-.187.8-.1,1.007.2s.149.568-.13,1c-.587.907-1.182,1.812-1.706,2.755A13.387,13.387,0,0,0,36.6,14.93c.581.19,1.134.379,1.692.548a.738.738,0,0,1,.189,1.4c-.673.452-1.337.916-2.017,1.357a.589.589,0,0,0-.313.564q.013,7.668.008,15.335c0,.114.01.23.018.364.134.006.25.016.364.016.775,0,1.552,0,2.328,0a.742.742,0,0,1,.831.86,4.6,4.6,0,0,1-3.658,4.5H14.593A8.869,8.869,0,0,1,13.14,39.3a4.477,4.477,0,0,1-2.207-4.011Q10.91,22.413,10.926,9.54V9.054h-.412c-1.9,0-3.806-.01-5.71.008A.916.916,0,0,1,3.8,8.426ZM34.7,19.449c-.128.08-.206.125-.282.176-1.4.949-2.8,1.894-4.2,2.856a1.042,1.042,0,0,0-.366.478c-.264.728-.488,1.47-.74,2.2a.711.711,0,0,1-1.167.389.753.753,0,0,1-.179-.872,26.178,26.178,0,0,0,.9-2.994,28.754,28.754,0,0,1,1.035-4.235,15.552,15.552,0,0,1,4.148-6.664,2.367,2.367,0,0,0,.871-2.072,3.559,3.559,0,0,0-3.6-3.6q-9.822-.012-19.642,0c-.085,0-.17.018-.3.032a5.489,5.489,0,0,1,1.169,3.792q-.03,13,0,26.006a4.963,4.963,0,0,0,.207,1.457,2.7,2.7,0,0,0,3.54,1.872,3.011,3.011,0,0,0,1.889-2.746c.069-.81.256-1.006,1.064-1.006H34.7ZM38.19,35.975H19.4a5.19,5.19,0,0,1-1.111,2.468c.1.01.134.017.169.017q8.479,0,16.955-.009a2.624,2.624,0,0,0,.99-.205A3.046,3.046,0,0,0,38.19,35.975Zm-1.2-25.754a11.843,11.843,0,0,0-4.442,4.452,18.294,18.294,0,0,0-2.18,5.963l6.194-4.2c-.316-.108-.579-.2-.845-.285-.663-.216-.8-.479-.627-1.163A20.669,20.669,0,0,1,36.994,10.221ZM10.806,7.592a2.883,2.883,0,0,0-2.817-2.48,2.872,2.872,0,0,0-2.6,2.48Z",
    transform: "translate(-3.8 -3.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_457",
    "data-name": "Trazado 457",
    d: "M27.332,31.007a3.083,3.083,0,1,1,3.081-3.094A3.09,3.09,0,0,1,27.332,31.007Zm-1.65-3.086a1.641,1.641,0,0,0,1.644,1.66,1.674,1.674,0,0,0,1.664-1.655,1.694,1.694,0,0,0-1.659-1.669A1.66,1.66,0,0,0,25.682,27.921Z",
    transform: "translate(-1.564 -1.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_458",
    "data-name": "Trazado 458",
    d: "M19.706,10.835c-1.468,0-2.935,0-4.4,0a.744.744,0,0,1-.82-.52.687.687,0,0,1,.48-.88,2.177,2.177,0,0,1,.524-.048q4.245,0,8.489,0a3.022,3.022,0,0,1,.317.008.7.7,0,0,1,.707.758.711.711,0,0,1-.75.681c-.387.011-.774,0-1.163,0Z",
    transform: "translate(-2.635 -3.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_459",
    "data-name": "Trazado 459",
    d: "M19.719,20.588c-1.514,0-3.029,0-4.544,0a.673.673,0,0,1-.7-.526.65.65,0,0,1,.292-.763.808.808,0,0,1,.428-.119q4.526-.01,9.052,0a.708.708,0,1,1,.013,1.413C22.748,20.592,21.233,20.589,19.719,20.588Z",
    transform: "translate(-2.635 -1.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_460",
    "data-name": "Trazado 460",
    d: "M19.746,17.336c-1.514,0-3.029,0-4.544,0a.707.707,0,0,1-.746-.607.688.688,0,0,1,.442-.758,1.723,1.723,0,0,1,.519-.053q3.734,0,7.467,0c.446,0,.892,0,1.338,0,.495.008.78.273.779.71a.691.691,0,0,1-.782.709C22.728,17.339,21.237,17.336,19.746,17.336Z",
    transform: "translate(-2.635 -2.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_461",
    "data-name": "Trazado 461",
    d: "M19.746,14.085c-1.491,0-2.982,0-4.473,0a.74.74,0,0,1-.823-.648A.707.707,0,0,1,15,12.68a2.5,2.5,0,0,1,.456-.027H24.01c.105,0,.212,0,.316.01A.681.681,0,0,1,25,13.4a.688.688,0,0,1-.712.678c-.833.011-1.666,0-2.5,0Q20.768,14.087,19.746,14.085Z",
    transform: "translate(-2.635 -2.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_462",
    "data-name": "Trazado 462",
    d: "M18.543,22.423h3.244a.626.626,0,0,1,.68.449,1.061,1.061,0,0,1-.118.714.724.724,0,0,1-.54.25q-3.313.025-6.629.008a.71.71,0,0,1-.738-.731.734.734,0,0,1,.787-.689C16.335,22.42,17.438,22.423,18.543,22.423Z",
    transform: "translate(-2.636 -1.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_463",
    "data-name": "Trazado 463",
    d: "M23.41,23.841a.694.694,0,0,1-.722-.7.721.721,0,0,1,.714-.717.7.7,0,0,1,.7.691A.676.676,0,0,1,23.41,23.841Z",
    transform: "translate(-1.733 -1.641)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConstituciones);
export default __webpack_public_path__ + "static/media/ic_constituciones.3d25e263dfa62cb4f4905116362cace0.svg";
export { ForwardRef as ReactComponent };